import { h } from 'preact'
import { StateUpdater } from 'preact/hooks'
import { i18n } from 'i18n/i18n'

import { CurrencyValueForm } from 'models/apps'
import { Calculation } from 'models/exchange-transfer-calculate'

import { CalculatorCurrencyInputWithSelect } from 'common-modules/calculator-currency-input-with-select'

import BuyTooltip from './buy-tooltip'

interface CurrencyInputGroupProps {
  inputId: string
  labelKey: string
  value: CurrencyValueForm
  onValueChange: StateUpdater<CurrencyValueForm>
  isBelowMinimalAmount: boolean
  isBaseCurrencyComponent: boolean
  debounceTime: number
  baseCurrency: string
  counterCurrency: string
  setBaseCurrency: (value: string) => void
  setCounterCurrency: (value: string) => void
  fixedCurrencyList: string[]
  exchangeData?: Calculation
}

const CurrencyInputGroup = ({
  inputId,
  labelKey,
  value,
  onValueChange,
  isBelowMinimalAmount,
  isBaseCurrencyComponent,
  debounceTime,
  baseCurrency,
  counterCurrency,
  setBaseCurrency,
  setCounterCurrency,
  fixedCurrencyList,
  exchangeData,
}: CurrencyInputGroupProps) => {
  return (
    <div className="double-input-calculator__input-group">
      {exchangeData ? (
        <div className="double-input-calculator__input-label-container">
          <label
            className="double-input-calculator__input-label"
            for={inputId}
          >
            {i18n(labelKey)}
          </label>
          <BuyTooltip exchangeData={exchangeData} />
        </div>
      ) : (
        <label
          className="double-input-calculator__input-label"
          for={inputId}
        >
          <span>{i18n(labelKey)}</span>
        </label>
      )}

      <CalculatorCurrencyInputWithSelect
        id={inputId}
        value={value}
        setValue={onValueChange}
        isBelowMinimalAmount={isBelowMinimalAmount}
        debounceTime={debounceTime}
        isBaseCurrencyComponent={isBaseCurrencyComponent}
        baseCurrency={baseCurrency}
        counterCurrency={counterCurrency}
        handleSetBaseCurrency={setBaseCurrency}
        handleSetCounterCurrency={setCounterCurrency}
        fixedCurrencyList={fixedCurrencyList}
      />
    </div>
  )
}

export default CurrencyInputGroup
